import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

export const createCoverageActions = (types, api) => ({
  cleanup: createAction(types.CLEANUP),
  initialized: createAction(types.INITIALIZED),
  changeSorting: createAction(types.CHANGE_SORTING),
  getCoverage: createApiAction(
    types.GET_COVERAGE,
    (params) => api.getCoverage(params),
    { meta: { skipErrorPage: true } },
  ),
  getCoverageCSV: createApiAction(
    types.GET_COVERAGE_CSV,
    (params) => api.getCoverageCSV(params),
    { meta: { skipErrorPage: true } },
  ),
});
